import { Button, Input } from 'components/atoms';
import { FormInput } from 'components/molecules';
import CountrySelectPopupForm from 'components/molecules/popup/country-select/CountrySelectPopupForm';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiAddressBook } from 'react-icons/pi';
import { useGetCountries } from 'services/enums';
import { ILabelForm } from 'services/labels/types';
import { getCountries } from 'utils/global/countries.utils';

interface IAddressFormProps {
  propertyPrefix: string;
  title?: string;
  icon?: ReactNode;
  topContent?: ReactNode;
  bottomContent?: ReactNode;
  appBackground?: boolean;
}

const AddressForm = ({
  icon = <PiAddressBook />,
  title,
  propertyPrefix = '',
  bottomContent,
  topContent,
  appBackground = true,
}: IAddressFormProps) => {
  const { t } = useTranslation();
  const { values, status, setFieldValue, errors, submitCount }: IFormikContextType<ILabelForm> =
    useFormikContext<ILabelForm>();
  const countries = useGetCountries();

  const currentValues = propertyPrefix === 'taxOffice.' ? values.taxOffice : values.address;

  const currentErrors = propertyPrefix === 'taxOffice.' ? errors.taxOffice : errors.address;

  const initialCountry =
    countries.data?.find((c) => c.codeAlfa2 === currentValues?.countryAlfa2) ?? null;

  const countryError = submitCount > 0 ? currentErrors?.countryAlfa2 : undefined;

  const countryValue =
    getCountries(countries.data)?.find((c) => c.value === currentValues?.countryAlfa2)?.label ?? '';

  return (
    <>
      {topContent}
      <div className="flex w-full gap-2 ">
        <CountrySelectPopupForm
          onSelectCountry={(country, actions) => {
            setFieldValue(`${propertyPrefix}countryAlfa2`, country.codeAlfa2);
            actions.close();
          }}
          initialCountry={initialCountry}
          trigger={
            <div className=" w-full cursor-pointer">
              <Input.Text
                name=""
                borderless
                fullWidth
                appBackground={appBackground}
                error={countryError}
                label={t('input.label.country')}
                value={countryValue}
                style={{ pointerEvents: 'none' }}
              />
            </div>
          }
        />
        <FormInput.Text
          name={`${propertyPrefix}zipCode`}
          label={t('input.label.zipCode')}
          borderless
          fullWidth
          appBackground={appBackground}
        />
      </div>
      <div className="flex w-full gap-2 ">
        <FormInput.Text
          name={`${propertyPrefix}city`}
          label={t('input.label.city')}
          borderless
          fullWidth
          appBackground={appBackground}
        />
        <FormInput.Text
          name={`${propertyPrefix}street`}
          label={t('input.label.street')}
          borderless
          fullWidth
          appBackground={appBackground}
        />
      </div>
      <div className="flex w-full gap-2 ">
        <FormInput.Text
          name={`${propertyPrefix}houseNumber`}
          label={t('input.label.houseNumber')}
          borderless
          fullWidth
          appBackground={appBackground}
        />
        <FormInput.Text
          name={`${propertyPrefix}flatNumber`}
          label={t('input.label.flatNumber')}
          borderless
          fullWidth
          appBackground={appBackground}
        />
      </div>
      {bottomContent}
    </>
  );
};

export default AddressForm;
